
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refersion-alternative",
      function () {
        return require("private-next-pages/refersion-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refersion-alternative"])
      });
    }
  